import { IBookingEngineState } from "@app/app/types";
import { AvailabilityRequestType } from "@app/availability/constants/AvailabilityRequestType";

export const getAvailabilitySearch = (
    search: URLSearchParams,
    state: IBookingEngineState,
    requestType?: AvailabilityRequestType
): URLSearchParams => {
    const params = new URLSearchParams();

    params.set("rt", String(requestType || AvailabilityRequestType.Get));

    const [ci, co] = (search.get("d") || "").split(",");

    params.set("ci", ci);
    params.set("co", co);

    const pc = search.get("pc") || state.promoCode;
    const cc = search.get("cc");

    if (pc) {
        params.set("pc", pc);
    }
    if (cc) {
        params.set("cc", cc);
    }

    // Get booking rooms from the new semicolon-separated format
    let bookingRooms: string[] = [];
    // Check for the new br parameter format first
    const brValue = search.get("br");
    if (brValue) {
        bookingRooms = brValue.split(";");
    }

    if (!bookingRooms.length) {
        bookingRooms = ["2435816bas,_,_,_,2,1:0,2:0"];
    }

    bookingRooms.forEach((br: string, i: number) => {
        const [bookings] = br.split("|");
        const props = (bookings || "").split(",");

        params.set(`rs[${i}][id]`, props[0]);
        params.set(`rs[${i}][ac]`, props[4]);

        // Parse child categories
        const childCounts = props.slice(5);

        childCounts.forEach((countStr) => {
            const [categoryId, count] = countStr.split(":");
            params.set(`rs[${i}][cc][${categoryId}]`, count);
        });
    });

    return params;
};
